export const getVersion = () => process.env.SEARCH_APP_VERSION;
